// src/components/SmartDashboardRedirect.jsx

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { startRouteForUserAsync } from "../utils/startRouteForUser";
import Dashboard from "../pages/Dashboard";

export default function SmartDashboardRedirect() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const { user, profile, loading, profileLoading } = useAuth();

  // 1. cas où on DOIT rediriger (admin / team / family_office / expert / partner / collaborateur)
  useEffect(() => {
    if (loading) return;
    if (profileLoading) return;
    if (!user) return;

    // Version async : détecte aussi les collaborateurs (table collaborators)
    (async () => {
      const { data: { session } } = await import("../lib/supabaseClient")
        .then(m => m.supabase.auth.getSession());

      const profileForRoute = profile || { role: "user" };
      const target = await startRouteForUserAsync(profileForRoute, session);

      if (target && target !== "/dashboard" && location.pathname !== target) {
        navigate(target, { replace: true });
      }
    })();
  }, [loading, profileLoading, user, profile, location.pathname, navigate]);

  // 2. loader initial tant qu'on ne sait pas qui est la personne
  if (loading || !user || profileLoading) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center text-gray-500">
        {t("smartDashboardRedirect.loadingDashboard")}
      </div>
    );
  }

  // ✅ Si on est authentifié mais profil indisponible (null), on rend le dashboard standard
  // (cas: profil pas créé / RLS / erreur fetch profil)
  // On évite ainsi un loader infini.

  // 2bis. Sécurité : un partenaire ne doit JAMAIS rendre le Dashboard client
  // La redirection est gérée par startRouteForUser(profile)
  if (profile?.role === "partner") {
    return (
      <div className="min-h-[50vh] flex items-center justify-center text-gray-500">
        {t("smartDashboardRedirect.loadingPartner")}
      </div>
    );
  }
  // 3. si on arrive ici :
  // soit on est déjà sur la bonne route ("/dashboard" pour un client normal)
  // soit le navigate() a déjà fait son boulot pour les rôles spéciaux.
  //
  // -> pour le rôle "client normal", on REND le vrai Dashboard.jsx
  return <Dashboard />;
}